<template>
  <div>
    <list
      row-key="DpId"
      ref="list"
      unit="部门信息"
      :page="false"
      expand-all-row
      :query-params="params"
      :show-checkbox="showCheckbox"
      :show-query="showQuery"
      :get-data-func="getDataFunc"
    >
      <template slot="query">
        <el-form-item label="部门名称">
          <el-input v-model="params.DpName" placeholder="请填写部门名称" />
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="DpName" label="部门名称" />
        <slot name="column"></slot>
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";

export default {
  mixins: [listMixin],
  components: { list },
  props: {},
  computed: {},
  mounted() {},
  data() {
    return {
      api: require("@/api/ent/dp").default,
      params: {
        DpName: "",
      },
      isMB: this.$store.state.isMB,
    };
  },
  methods: {
    getDataFunc(params) {
      return new Promise((resolve, reject) => {
        this.api.getTreeList(params).then((res) => {
          let Data = this.$commonJs.toTreeData(res.Data, "DpId");
          resolve({ Data });
        });
      });
    },
  },
};
</script>
<style lang="scss"></style>